<template>
	<div>
		<slot></slot>
	</div>
</template>

<script lang="ts" setup></script>
